import { EventUsers } from "../../models/events";

export function sortUsersByPaidStatus(users: EventUsers[] | undefined) {
    return users?.sort((a: { paid: number; }, b: { paid: number; }) => b.paid - a.paid);
  }